import Constant from "../Constant";
const Util = {};

Util.sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

Util.validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

export default Util;
